<template>
    <div class="our-work" v-if="casesReady">
        <div v-html="title" class="our-work--title"></div>
        <div class="our-work-swiper-container swiper-container wide-slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide" :key="index" v-for="(caseitem, index) in cases">
                    <router-link tag="div" class="box" :to="'/'+ slug +'/'+ caseitem.slug">
                        <div
                            class="bg"
                            :style="{ 'background-image': 'url( ' + (caseitem && caseitem.better_featured_image && caseitem.better_featured_image.source_url) + ' )'}"
                        ></div>

                        <span
                            class="title"
                            v-html="caseitem && caseitem.title && caseitem.title.rendered"
                        ></span>
                    </router-link>
                </div>
            </div>
            <div class="our-work-swiper-prev our-work-wide-slider-prev"></div>
            <div class="our-work-swiper-next our-work-wide-slider-next"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata", "slug", "post_id"],
    name: "our-work-slider",
    data() {
        return {
            title: this.blockdata.text,
            cases: null,
            casesReady: false
        };
    },
    mounted: function() {
        this.fetchData();
    },
    methods: {
        fetchData: function() {
            var self = this;
            $.get(
                self.$root.apiUrl +
                    "wp-json/wp/v2/cases_studies" +
                    "?exclude=" +
                    self.post_id,
                function(response) {
                    self.cases = response;
                    self.casesReady = true;
                    setTimeout(function() {
                        var ourWorkSwiper = new Swiper(
                            ".our-work-swiper-container",
                            {
                                loop: true,
                                slidesPerView: "auto",
                                centeredSlides: true,
                                initialSlide: 0,
                                nextButton: ".our-work-swiper-next",
                                prevButton: ".our-work-swiper-prev",
                                speed: 500
                            }
                        );
                    }, 200);
                }
            )
                .done(function() {})
                .fail(function() {});
        }
    }
};
</script>



// WEBPACK FOOTER //
// OurWorkSlider.vue?43830403